// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"11edb281","27":"982979b1","56":"dddf1869","508":"f6bd7ff5","584":"021eb4ec","685":"594338f4","709":"dacbb268","741":"ad50f978","825":"25dee88c","873":"66e437e7","885":"58f703a3","917":"db5c280f","961":"b4d611e9"}[chunkId] + ".chunk.js";
};